<template>
  <div>
    <CRow>
      <CCol sm="12">
        <CRow class="search-panel">
          <CCol
            xs="12"
            sm="1"
            class="mr-0"
            style="min-width: 90px; max-width: 100px;"
          >
            <div class="dropdown">
              <button
                class="btn dropdown-toggle"
                type="button"
                id="dropdownMenuButton"
                data-toggle="dropdown"
                aria-expanded="false"
              >
                Action
              </button>
              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <button
                  class="dropdown-item"
                  @click="setupThreadAction('start_all')"
                >
                  <CIcon name="cil-power-standby" class="mr-2"/>
                  Start all
                </button>
                <button
                  class="dropdown-item"
                  @click="setupThreadAction('stop_all')"
                >
                  <CIcon name="cil-power-standby" class="mr-2"/>
                  Stop all
                </button>
                <button
                  class="dropdown-item"
                  @click="setupThreadAction('reload_all')"
                >
                  <CIcon name="cil-reload" class="mr-2"/>
                  Reload
                </button>
              </div>
            </div>
          </CCol>
          <CCol sm="3" xs="12">
            <div style="position: relative;">
              <BaseInput
                :options="nameOrIdInput.options"
                :data="nameOrIdInput.data"
                :listener="nameOrIdInput.listener"
              />
            </div>
          </CCol>
          <CCol>
            <CButton
              color="primary" ref="refreshBtn"
              v-c-tooltip.hover="'Refresh'"
              class="btn-action-primary"
              @click="loadDataMainTable"
              style="float: right;"
            >
              <i class="fa fa-refresh"></i>&nbsp;&nbsp; Refresh
            </CButton>
          </CCol>
        </CRow>
        <CCard class="mt-3p5 content-fade-in">
          <CCardBody>
            <BaseTable
              :options="mainTable.options"
              :slots="mainTable.slots"
              :dataSource="mainTable.dataSource"
              ref="mainTable"
            >
              <template #index="{index}">
                <td>
                  <span>{{
                    $refs.mainTable.getTotalElementByPage + index
                  }}</span>
                </td>
              </template>
              <template slot="id" slot-scope="data">
                <td>
                  <span>{{ data.item.id }}</span
                  ><br/>
                  <span class="children-title">{{ data.item.name }}</span>
                </td>
              </template>

              <template #status="{item}">
                <td>
                  <span v-if="item.status" class="dot-custom dot-success"
                  >Running</span
                  >
                  <span v-else class="dot-custom dot-danger">Stopped</span>
                </td>
              </template>

              <template #state="{item}">
                <td>
                  <CBadge v-if="item.state == 0" color="info">Normal</CBadge>
                  <CBadge color="info" v-else-if="item.state == 1">Info</CBadge>
                  <CBadge color="warning" v-else-if="item.state == 2"
                  >Warn
                  </CBadge
                  >
                  <CBadge color="danger" v-else-if="item.state == 3"
                  >Error
                  </CBadge
                  >
                  <CBadge color="success" v-else-if="item.state == 4"
                  >Idle
                  </CBadge
                  >
                </td>
              </template>

              <template #action="{item}">
                <td class="group-action">
                  <CButton
                    v-if="item.status == false"
                    color="success"
                    @click="setupThreadAction('start_one', item.id)"
                  >
                    &nbsp;<i class="fa fa-power-off"></i>&nbsp;Start
                  </CButton>
                  <CButton
                    v-else
                    color="danger"
                    @click="setupThreadAction('stop_one', item.id)"
                  >
                    <i class="fa fa-power-off"></i>&nbsp;Stop
                  </CButton>
                </td>
              </template>
            </BaseTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <ModalConfirm
      :actionTypeMapping="actionData.actionTypeMapping"
      ref="actionModal"
    >
    </ModalConfirm>
  </div>
</template>

<script>
  import BaseTable from "../base/BaseDataTable";
  import ModalConfirm from "../base/BaseModalConfirm";
  import BaseInput from "../base/BaseInput";

  export default {
    name: "ThreadList",
    components: {BaseTable, ModalConfirm, BaseInput},
    notifications: {
      showSuccessMsg: {
        type: "success",
        title: "Success"
      },
      showErrorMsg: {
        type: "error",
        title: "Error"
      },
      showWarningMsg: {
        type: "warn",
        title: "warn"
      }
    },
    data() {
      var that = this;
      var actionTypeMapping = new Map();
      actionTypeMapping.set("start_all", {
        url: "/thread/start_all_threads",
        titlePopup: function () {
          return that.$helper.setupTitleAction("start all", "tiến trình");
        },
        successCallback: function () {
          that.showSuccessMsg({
            message: "Cập nhật danh sách tiến trình thành công"
          });
          that.loadDataMainTable();
        }
      });
      actionTypeMapping.set("stop_all", {
        url: "/thread/stop_all_threads",
        titlePopup: function () {
          return that.$helper.setupTitleAction("stop all", "tiến trình");
        },
        successCallback: function () {
          that.showSuccessMsg({
            message: "Cập nhật danh sách tiến trình thành công"
          });
          that.loadDataMainTable();
        }
      });
      actionTypeMapping.set("reload_all", {
        url: "/thread/reload_thead_config",
        titlePopup: function () {
          return that.$helper.setupTitleAction("reload all", "tiến trình");
        },
        successCallback: function () {
          that.showSuccessMsg({
            message: "Cập nhật tiến trình thành công"
          });
          that.loadDataMainTable();
        }
      });
      actionTypeMapping.set("start_one", {
        url: "/thread/startById",
        isJsonContentType: false,
        titlePopup: function () {
          return that.$helper.setupTitleAction(
            "start",
            "tiến trình",
            that.actionData.model.threadSelectedId
          );
        },
        dataSubmit: function () {
          return {
            id: that.actionData.model.threadSelectedId
          };
        },
        successCallback: function () {
          that.showSuccessMsg({
            message: "Cập nhật tiến trình thành công"
          });
          that.loadDataMainTable();
        }
      });
      actionTypeMapping.set("stop_one", {
        url: "/thread/stopById",
        isJsonContentType: false,
        titlePopup: function () {
          return that.$helper.setupTitleAction(
            "stop",
            "tiến trình",
            that.actionData.model.threadSelectedId
          );
        },
        dataSubmit: function () {
          return {
            id: that.actionData.model.threadSelectedId
          };
        },
        successCallback: function () {
          that.showSuccessMsg({
            message: "Cập nhật tiến trình thành công"
          });
          that.loadDataMainTable();
        }
      });

      return {
        nameOrIdInput: {
          options: {
            type: "text",
            placeholder: "Id hoặc tên tiến trình"
          },
          data: {
            name: "displayName",
            model: "",
            updateTrigger: function () {
              return that.$refs.mainTable;
            }
          }
        },
        actionData: {
          actionTypeMapping: actionTypeMapping,
          model: {
            threadSelectedId: null
          }
        },
        mainTable: {
          options: {
            noPaging: true,
            fields: [
              {key: "index", label: "STT"},
              {key: "id", label: "Thread ID/Name"},
              {key: "status", label: "State"},
              {key: "state", label: "Info"},
              {key: "action", label: "Action"}
            ],
            slots: ["index", "id", "status", "state", "action"]
          },
          dataSource: {
            url: "/thread/list",
            isJsonContentType: false,
            dataRef: function () {
              return that.$data;
            },
            response: function (dataResponse) {
              return dataResponse.data;
            },
            btnCallAjaxs: function () {
              return [that.$refs.refreshBtn]
            },
            resultListAttrName: "threads"
          }
        }
      };
    },
    methods: {
      loadDataMainTable: function () {
        this.$refs.mainTable.loadData();
      },
      setupThreadAction: function (actionTypeKey, threadSelectedId) {
        this.actionData.model.threadSelectedId = threadSelectedId || null;
        this.$refs.actionModal.setCurrAction(actionTypeKey);
      }
    },
    computed: {},
    beforeCreate: function () {
    },
    created: function () {
    },
    mounted() {
    },
    watch: {}
  };
</script>
<style scoped></style>
